module.exports = __webpack_public_path__ + "img/coder_logo.19977655.svg";